export const SYS_ID_MODES = {
  ADD: 'add',
  EDIT: 'edit',
};

export const sysIdModeToFlag = (mode) => {
  if (mode === SYS_ID_MODES.ADD) return 0;
  if (mode === SYS_ID_MODES.EDIT) return 1;
  return null;
};
